<template>
	<div class="card card-shape home-box">
		<div
			class="card-header d-flex flex-row align-items-center justify-content-between">
			<h6 class="m-0 fw-bold text-green">Multiple Ro Transfer</h6>
			<b-link
				title="Download Excel Format"
				@click="downloadFile"
				class="fw-semibold ms-2 akkurate-green">
				<font-awesome-icon :icon="['fas', 'download']"
			/></b-link>
		</div>
		<div class="card-body">
			<div class="err-accounts text-center my-2">
				<errors v-if="message">
					{{ message }}
				</errors>
			</div>
			<div class="card card-shape home-box mb-3 border border-success">
				<div class="card-body py-2">
					<div class="row mb-3">
						<div class="col-md-9">
							<div class="row">
								<div class="col">
									<label
										class="akkurate-dark small"
										for="phone"
										>Choose File<star></star
									></label>
									<input
										type="file"
										class="form-control mt-2"
										@change="handleFileUpload"
										ref="fileInput"
										accept=".xlsx,.xls" />
								</div>
								<div class="col mt-auto">
									<label
										class="akkurate-dark small"
										for="total_count"
										>Total Records</label
									>
									<div class="mt-2">{{ total_count }}</div>
								</div>
								<!-- <div class="col mt-auto">
                            <label class="akkurate-dark small" for="total_a">Total Amount<star></star></label>
                            <div class="mt-2">{{ total_amount }}</div>
                          </div> -->
							</div>
						</div>
						<div class="col mt-auto">
							<b-button
								:disabled="(isSaving || isLoading || !loaded)"
								class="btn-size w-75 akkurate-green-btn"
								@click="addBulkRoTransfer"
								><font-awesome-icon
									class="small"
									:icon="['fas', 'upload']" />
								Import</b-button
							>
						</div>
					</div>
				</div>
			</div>

			<div class="row">
				<div class="col-md-12">
					<div class="text-center text-danger my-2" v-if="isLoading">
						<b-spinner class="align-middle"></b-spinner>
						<strong>Loading...</strong>
					</div>
					<vue-good-table
						styleClass="vgt-table bordered striped"
						mode="remote"
						ref="allAccountTable"
						:columns="ro_columns"
						:rows="ro_rows"
						:isLoading.sync="isLoading"
						:totalRows="totalRecords"
						:select-options="{
							enabled: true,
							disableSelectInfo: true, // disable the select info panel on top
						}">
						<!-- Add your custom delete button column -->
						<!-- <template slot="table-row" slot-scope="props">
                        <span v-if="props.column.field == 'member_fullname'">
                          <span>
                            {{ props.row.customer?.first_name }}
                            {{ props.row.customer?.last_name }}
                          </span>
                        </span>
                        <span v-else>
                          {{ props.formattedRow[props.column.field] }}
                        </span>
                      </template> -->
					</vue-good-table>
				</div>
			</div>
		</div>
	</div>
</template>


<script>
	import ApiService from "@/core/services/api.service";
	import config from "@/config.js";
	import * as XLSX from "xlsx";

	export default {
		components: {
		},
		data() {
			return {
				...this.initialState(),
				message: null,
				// jsonData:null,
				ro_columns: [
					{
						label: "Code",
						field: "code",
						width: "150px",
					},
					{
						label: "External Code",
						field: "externalcode",
						width: "150px",
					},
					{
						label: "Name",
						field: "name",
						type: "string",
						width: "200px",
					},
					{
						label: "Ro Name",
                        field: "ro_name",
                        width: "200px",
						type: "string",
                    },
					{
						label: "Ro Code",
                        field: "ro_code",
                        width: "150px",
						type: "string",
                    },
				],
				ro_rows: [],
				serverParams: {
					// a map of column filters example: {name: 'john', age: '20'}
					columnFilters: {},
					sort: [
						{
							field: "", // example: 'name'
							type: "", // 'asc' or 'desc'
						},
					],
					page: 1, // what page I want to show
					perPage: 20, // how many items I'm showing per page
				},
			};
		},
		methods: {
			parseDate(dateString) {
				const parts = dateString.split("/");
				// parts[0] is the day, parts[1] is the month, parts[2] is the year
				return new Date(parts[2], parts[1] - 1, parts[0]); // month is 0-based
			},
			// handleFileUpload(event) {
			// 	this.excelFile = event.target.files[0];
			// 	if (this.excelFile) {
			// 		const reader = new FileReader();
			// 		reader.onload = (e) => {
			// 			const data = new Uint8Array(e.target.result);
			// 			const workbook = XLSX.read(data, { type: "array" });
			// 			const sheetName = workbook.SheetNames[0];
			// 			const sheet = workbook.Sheets[sheetName];
			// 			const jsonData = XLSX.utils.sheet_to_json(sheet, {
			// 				header: 1,
			// 			});

			// 			// Convert to JSON
			// 			const headers = jsonData[0];
			// 			const jsonDataArray = [];
			// 			let roCode = null;
			// 			for (let i = 1; i < jsonData.length; i++) {
			// 				const row = jsonData[i];
			// 				const obj = {};
			// 				for (let j = 0; j < headers.length; j++) {
			// 					const key = headers[j]
			// 						.replace(/\s/g, "_")
			// 						.toLowerCase(); // Replace spaces with underscores
			// 					let value = null;
			// 					if (row[j]) {
			// 						let normalValue = row[j]
			// 						if (key == "ro_code") {
			// 							roCode = normalValue

			// 						}
			// 						value = String(normalValue); // Convert value to string
			// 					}
								
			// 					console.log();
			// 					console.log(key, roCode)
			// 					if (key == "ro_name" && roCode != null) {
			// 						console.log("Getting users")
			// 						this.isLoading = true
			// 						this.loaded = false

			// 						if(i == (jsonData.length -1))
			// 							value = this.getRo(roCode,true)
			// 						else
			// 							value = this.getRo(roCode)
			// 					}
			// 					obj[key] = value;
			// 				}
			// 				jsonDataArray.push(obj);
			// 			}
			// 			this.total_count = jsonDataArray.length;

			// 			// Call showExcelUploads with the processed data
			// 			this.showExcelUploads(jsonDataArray);
			// 		};
			// 		reader.readAsArrayBuffer(this.excelFile);
			// 	} else {
			// 		this.showExcelUploads([]); // Handle the case where no file is selected
			// 	}
			// },
			async handleFileUpload(event) {
				this.excelFile = event.target.files[0];
				if (!this.excelFile) {
					this.showExcelUploads([]);
					return;
				}

				const reader = new FileReader();

				reader.onload = async (e) => {
					const data     = new Uint8Array(e.target.result);
					const workbook = XLSX.read(data, { type: "array" });
					const sheet    = workbook.Sheets[workbook.SheetNames[0]];
					const jsonData = XLSX.utils.sheet_to_json(sheet, { header: 1 });

					const headers      = jsonData[0];
					const jsonDataArray = [];

					// 1. First pass — build rows without RO names
					for (let i = 1; i < jsonData.length; i++) {
						const row = jsonData[i];
						const obj = {};

						for (let j = 0; j < headers.length; j++) {
							const key   = headers[j].replace(/\s/g, "_").toLowerCase();
							const value = row[j] !== undefined ? String(row[j]) : null;
							obj[key]    = value;
						}

						// Only push non-empty rows
						if (Object.values(obj).some(v => v !== null)) {
							jsonDataArray.push(obj);
						}
					}

					// 2. Second pass — resolve all RO names async in parallel
					this.isLoading = true;
					this.loaded    = false;

					await Promise.all(
						jsonDataArray.map(async (obj) => {
							if (obj.ro_code) {
								obj.ro_name = await this.getRo(obj.ro_code);
							}
						})
					);

					this.isLoading = false;
					this.loaded    = true;
					this.total_count = jsonDataArray.length;

					this.showExcelUploads(jsonDataArray);
				};

				reader.readAsArrayBuffer(this.excelFile);
			},
			async addBulkRoTransfer() {
                this.isSaving = true;
                // ADD THIS
                console.log("excelFile:", this.excelFile);
    
				const payload = new FormData();
				payload.append(
					"ro_rows",
					JSON.stringify(this.ro_rows)
				); // Convert to string if needed
				payload.append("excel_upload_id", "id");
				if (this.excelFile) {
					payload.append("excelFileInput", this.excelFile);
				}
				// console.log(this.excelFile);

				await ApiService.post("/customers/transfer-ro/import/store", payload)
					.then((response) => {
						this.isLoadingSaving = false;
						this.$Progress.finish();

						swal.fire({
							icon: "success",
							title: "Success",
							text: response.data.message,
							showCancelButton: false, // Show the "Cancel" button
							confirmButtonText: "OK", // Customize the text for the "OK" button
							buttonsStyling: false, // Disable SweetAlert2 styling for buttons
							customClass: {
								confirmButton:
									"btn btn-size akkurate-green-btn modal-btn-width text-white me-2", // Custom class for the "OK" button
							},
						});

						this.isSaving = false;
						// this.form.reset();
						this.form = this.initialState().form;
						this.ro_rows = [];
						// this.form.gl_debit = "";
					})
					.catch((error) => {
						this.isSaving = false;
						this.$Progress.fail();
						console.log(error);
						if (error.response.data) {
							this.message = error.response.data.message;
						}
                    });
                    
			},
			showExcelUploads(ro_rows) {
				console.log("Received account rows:", ro_rows);
				this.ro_rows = ro_rows; // Update the ro_rows data property
			},

			initialState() {
				return {
					totalRecords: 0,
					searchFilter: "",
					total_count: 0,
					form: {
						external_code: null,
						first_name: [],
						middlename: "",
						last_name: "",
						// gl_debit_option: [],
						email: "",
						mobile: "",
						gender: "",
						date_of_birth: "",
						marital_status: "",
						customer_type: "",
						staff_id: "",
						address: "",
						postal_address: "",
						branch_code: "",
					},
					isLoading: true,
					loaded: false,
					isSaving: false,
					add_or_edit: "add",
				};
			},
			downloadFile() {
				// Replace 'example.pdf' with the filename you want to download from your public directory
				const fileName = "RO_TRANSFER_TEMPLATE.xlsx";

				// console.log(fileName);

				// Construct the URL to the file in the public directory
				const fileUrl = `${config.base_url}/assets/${fileName}`;

				//   console.log(fileUrl);

				// Create a link element
				const link = document.createElement("a");
				link.href = fileUrl;
				link.download = fileName;

				// Append the link to the body
				document.body.appendChild(link);

				// Programmatically click the link to trigger the download
				link.click();

				// Remove the link from the body
				document.body.removeChild(link);
			},
			async getRo(id, islast = false) {
				try {
					const res = await ApiService.get('users/get-ro/' + id);

					if (islast) {
						this.isLoading = false;
						this.loaded = true;
					}

					return res.data.user.first_name + " "+ (res.data.user.middle_name? res.data.user.middle_name+" ":"")+res.data.user.surname
				} catch (error) {
					console.log(error);
					return ""
				}

				return ""
			}
		},
	};
</script>
